module.exports = __webpack_public_path__ + "img/xin-jilu.b35a5f64.png";